const en = {
  brand: "DIGITAL COMPANY",
  brandLine: "B2B DIGITAL & AI SOLUTIONS",
  tagline: "From the first impression to the sale.",
  nav: {
    home: "Home",
    services: "Services",
    projects: "Work",
    solutions: "Solutions",
    whyB2b: "Why B2B?",
    about: "About",
    contact: "Contact",
    cta: "Request a quote",
    dropdown: [
      { label: "B2B Advertising", to: "/b2b-advertising" },
      { label: "Websites", to: "/websites" },
      { label: "CRM", to: "/crm" },
      { label: "AI Secretary", to: "/ai-secretary" },
      { label: "Business Email", to: "/business-email" },
    ],
  },
  hero: {
    label: "B2B DIGITAL & AI SOLUTIONS",
    lines: ["The technology behind", "your B2B company's", "growth."],
    sub: "B2B Advertising, Websites, CRM and AI tools working together in one integrated digital system.",
    cta1: "Request a free assessment",
    cta2: "Explore our solutions",
    strip: "B2B ADS • WEB • CRM • AI • BUSINESS EMAIL",
    flow: ["AD", "WEBSITE", "LEAD", "AI", "CRM", "SALE"],
    flowLabels: ["B2B Ad", "Website", "Lead", "AI Secretary", "CRM", "Sale"],
  },
  marquee: ["FROM THE FIRST IMPRESSION TO THE SALE", "B2B ADVERTISING", "WEBSITES", "CRM", "AI SECRETARY", "BUSINESS EMAIL"],
  services: {
    eyebrow: "SERVICES",
    title: "Five solutions. One digital ecosystem.",
    sub: "We don't sell fragmented services. We design systems that work together — from first impression to the sale.",
    cards: [
      { num: "01", title: "B2B ADVERTISING", desc: "Targeted advertising for new business opportunities.", to: "/b2b-advertising" },
      { num: "02", title: "WEBSITES", desc: "Greek and English websites designed for business.", to: "/websites" },
      { num: "03", title: "CRM", desc: "Organise leads, customers and sales.", to: "/crm" },
      { num: "04", title: "AI SECRETARY", desc: "Your company's intelligent first line of communication.", to: "/ai-secretary" },
      { num: "05", title: "BUSINESS EMAIL", desc: "Professional communication on your own domain.", to: "/business-email" },
    ],
  },
  flow: {
    eyebrow: "THE ECOSYSTEM",
    title: "From the first impression to the sale.",
    copy: "We don't treat advertising, websites, artificial intelligence and CRM as separate tools. We connect them into a single digital ecosystem that helps your business attract new professional contacts, serve them, organise them and turn them into commercial opportunities.",
    steps: ["B2B ADS", "WEBSITE", "LEAD", "AI SECRETARY", "CRM", "FOLLOW-UP", "CUSTOMER"],
  },
  work: {
    eyebrow: "OUR WORK",
    title: "From concept to real-world application.",
    sub: "Selected websites, e-commerce stores and web applications we have already built.",
    cta: "View the Project",
    allCta: "View all projects",
  },
  ads: {
    eyebrow: "01 — B2B ADVERTISING",
    title: "We don't chase followers. We create business opportunities.",
    copy: "B2B advertising follows a different logic than simple B2C social media marketing. We don't count likes and engagement — we design campaigns on Facebook, Instagram and Meta Ads that bring B2B leads, quote requests and professional partnerships.",
    bullets: ["B2B Leads", "New business clients", "Quote requests", "Dealers & Distributors", "Wholesalers", "Commercial opportunities"],
    channels: ["Facebook", "Instagram", "Meta Ads"],
    cta: "Discuss your campaign",
  },
  web: {
    eyebrow: "02 — WEBSITES & WEB DEVELOPMENT",
    title: "Your business in Greece and abroad.",
    copy: "We build Greek and English corporate websites that present your business professionally to the Greek and international markets.",
    message: "Your website is not just your digital presence. It is a sales tool.",
    chips: ["Exporters", "Manufacturers", "Producers", "Wholesalers", "Suppliers", "B2B Service Companies"],
    cta: "Explore Web solutions",
  },
  ai: {
    eyebrow: "04 — AI SECRETARY",
    title: "Your business available 24/7.",
    sub: "From the first question to the CRM, automatically.",
    copy: "The AI Secretary is not a simple chatbot. It is an AI Business Assistant that, depending on the implementation, supports your company's first line of communication.",
    bullets: ["Answers to frequent questions", "Lead capture & qualification", "Request logging", "Appointment requests", "Request routing", "CRM connection", "Sales rep notification", "Follow-up workflows", "24/7 digital availability"],
    cta: "Request a Demo",
    chat: {
      customer: "Hello. I'm interested in a business partnership.",
      ai: "Of course. What is your company name?",
      company: "ABC INDUSTRIES",
      email: "sales@example.gr",
      interest: "B2B Partnership",
      status: "QUALIFIED LEAD",
      action: "ADDED TO CRM",
      typing: "AI Secretary is typing…",
      demo: "Illustrative demo conversation",
    },
  },
  crm: {
    eyebrow: "03 — BUSINESS CRM",
    title: "Every lead. Every conversation. Every opportunity. In one place.",
    sub: "Never let a business opportunity slip away.",
    copy: "Organise customers, leads, opportunities and sales in one system — from the first contact to a closed deal.",
    stats: ["LEADS", "ACTIVE OPPORTUNITIES", "FOLLOW-UPS", "DEALS WON"],
    pipeline: ["NEW LEAD", "CONTACTED", "MEETING", "OFFER", "WON"],
    demo: "Illustrative demo data — not real client results.",
    cta: "Request a CRM presentation",
  },
  aicrm: {
    eyebrow: "AI + CRM",
    title: "AI that works with your sales team.",
    copy: "The AI Secretary can act as your company's first digital point of contact, collect the necessary information and, where the relevant integration exists, pass it to the CRM so your sales team can continue the conversation.",
    steps: ["Incoming Lead", "AI Conversation", "Contact Information", "CRM", "Sales Representative"],
    cta: "See how it works",
  },
  webapps: {
    eyebrow: "WEB APPLICATIONS",
    title: "Beyond websites — digital tools for your business.",
    copy: "We design and develop custom web applications around real business processes.",
    bullets: ["Business Web Applications", "Management Applications", "Internal Business Tools", "Customer Portals", "Sales Applications", "Digital Platforms", "Custom business workflows"],
    exampleLabel: "Real-world example",
    example: "ESPAMANAGER.GR — a platform for managing funding applications with automated document checks.",
    cta: "View the project",
  },
  email: {
    eyebrow: "05 — BUSINESS EMAIL",
    title: "Professional communication with your corporate identity.",
    copy: "Professional company email through reliable mail server infrastructure, as a complementary part of your digital ecosystem.",
    examples: ["info@company.gr", "sales@company.gr", "name@company.gr"],
    bullets: ["Email hosting", "Company email accounts", "Webmail", "Mobile & desktop access", "Email configuration", "Account management", "Technical support"],
    cta: "Request a quote",
  },
  b2b: {
    eyebrow: "WHY B2B",
    title: "100% B2B focus.",
    copy: "Business-to-business sales work differently. Longer sales cycles, more touchpoints, different decision makers and a need for organised follow-up. That is why we design our digital solutions around the real needs of a B2B commercial process.",
    highlights: ["TARGETING", "LEADS", "FOLLOW-UP", "CRM", "AI", "SALES"],
  },
  ecosystem: {
    eyebrow: "THE ECOSYSTEM",
    title: "One ecosystem. Five digital solutions.",
    copy: "Each service works on its own — but the real power lies in how they connect.",
    center: "YOUR BUSINESS",
    nodes: ["ADVERTISING", "WEBSITE", "AI", "CRM", "EMAIL"],
  },
  usecases: {
    eyebrow: "USE CASES",
    title: "Solutions designed around your business.",
    cards: [
      { title: "MANUFACTURER", items: ["Website GR/EN", "B2B Lead Generation"] },
      { title: "WHOLESALER", items: ["Advertising", "CRM"] },
      { title: "EXPORT COMPANY", items: ["English Website", "Digital Presence"] },
      { title: "B2B SERVICES", items: ["Website", "AI Secretary", "CRM"] },
      { title: "SALES TEAM", items: ["CRM", "Lead Management", "Follow-up"] },
    ],
  },
  packages: {
    eyebrow: "PACKAGES",
    title: "Structured solutions for every stage of growth.",
    sub: "No published prices — every proposal is shaped around your company's real needs.",
    badge: "COMPLETE SOLUTION",
    cta: "Request a quote",
    ctaDemo: "Request a presentation",
    list: [
      { name: "B2B PRESENCE", features: ["Corporate Website", "GR / EN", "Business Email", "Contact Forms", "Analytics"], highlight: false },
      { name: "B2B GROWTH", features: ["Website", "B2B Advertising", "Landing Pages", "Lead Generation", "Analytics", "Reporting"], highlight: false },
      { name: "B2B COMPLETE", features: ["Website", "B2B Advertising", "AI Secretary", "CRM", "Business Email", "Lead Management", "Sales Pipeline", "Integrations", "Reporting"], highlight: true },
    ],
  },
  finalCta: {
    title: "Let's design your company's next digital step.",
    sub: "Send us your request and we will get in touch.",
  },
  form: {
    name: "Full name",
    company: "Company",
    email: "Email",
    phone: "Phone",
    website: "Website",
    servicesLabel: "Services you're interested in",
    services: ["B2B Advertising", "Website", "Web Application", "CRM", "AI Secretary", "Business Email", "Complete solution"],
    message: "Tell us a few words about your business.",
    privacy: "I consent to the processing of my data according to the Privacy Policy.",
    submit: "Send request",
    sending: "Sending…",
    success: "Your request has been sent. We will contact you shortly.",
    error: "Something went wrong. Please try again.",
    required: "Please fill in the required fields.",
  },
  footer: {
    line: "B2B Digital & AI Solutions",
    servicesTitle: "SERVICES",
    services: [
      { label: "B2B Advertising", to: "/b2b-advertising" },
      { label: "Websites", to: "/websites" },
      { label: "Web Applications", to: "/websites" },
      { label: "CRM", to: "/crm" },
      { label: "AI Secretary", to: "/ai-secretary" },
      { label: "Business Email", to: "/business-email" },
    ],
    companyTitle: "COMPANY",
    company: [
      { label: "About", to: "/about" },
      { label: "Work", to: "/projects" },
      { label: "Contact", to: "/contact" },
    ],
    legalTitle: "LEGAL",
    legal: [
      { label: "Privacy Policy", to: "/privacy-policy" },
      { label: "Cookies Policy", to: "/cookies" },
    ],
    rights: "© 2026 DIGITAL COMPANY. All rights reserved.",
  },
  cookieConsent: {
    text: "We use strictly necessary cookies for the site to function and — only with your consent — analytics cookies.",
    accept: "Accept all",
    essential: "Essential only",
  },
  projectsPage: {
    title: "Our work",
    sub: "From corporate websites and online stores to web applications, we build digital solutions around real business needs.",
    visit: "Visit",
  },
  projectDetail: {
    back: "Back to projects",
    type: "TYPE",
    overview: "OVERVIEW",
    services: "SERVICES",
    website: "WEBSITE",
    visit: "Visit the website",
    cta: "Want something similar for your business?",
    ctaBtn: "Talk to us",
  },
  solutions: {
    eyebrow: "SOLUTIONS",
    title: "Digital solutions around the B2B sales process.",
    sub: "We combine advertising, web, AI and CRM into practical solutions based on your company's type and stage.",
  },
  about: {
    eyebrow: "ABOUT",
    title: "Marketing, Technology & AI in one unified B2B ecosystem.",
    copy: "DIGITAL COMPANY is a Greek B2B Digital & AI Technology Solutions company. We design and build digital systems for businesses that sell to other businesses — from the first impression to the sale.",
    copy2: "Our work is reflected in real, completed projects — from web applications like ESPAMANAGER.GR to bilingual corporate websites and e-commerce.",
    principles: [
      { title: "B2B FIRST", desc: "We design exclusively around the needs of businesses that sell to other businesses." },
      { title: "BUSINESS FOCUS", desc: "Every solution is evaluated by business criteria: leads, sales, organisation." },
      { title: "INTEGRATED SOLUTIONS", desc: "Advertising, web, AI and CRM work as one unified system." },
      { title: "TECHNOLOGY", desc: "Modern technologies and reliable infrastructure in every implementation." },
      { title: "AUTOMATION", desc: "We automate repetitive processes so your team can focus on sales." },
      { title: "DIGITAL DEVELOPMENT", desc: "From corporate websites to custom web applications and digital platforms." },
    ],
    workTitle: "Proof in practice.",
    workCopy: "See real projects we have already designed and developed.",
    workCta: "View our work",
  },
  contactPage: {
    eyebrow: "CONTACT",
    title: "Talk to us.",
    sub: "Tell us what your business needs and we will propose the right digital solution.",
    addressLabel: "ADDRESS",
    address: "58 Karterou",
    city: "Heraklion, Crete",
    phoneLabel: "PHONE",
    phone: "+30 6989 164 257",
    emailLabel: "EMAIL",
    email: "info@digital-company.gr",
    formNote: "Prefer writing?",
    formLink: "Send us a request via the form",
    mapTitle: "Map — 58 Karterou, Heraklion, Crete",
  },
  spages: {
    "b2b-advertising": {
      eyebrow: "01 — SERVICE",
      title: "B2B Advertising",
      lead: "Targeted campaigns on Facebook, Instagram and Meta Ads with one goal: real business opportunities — not just engagement.",
      message: "We don't chase followers. We create business opportunities.",
      blocks: [
        { title: "B2B audience targeting", desc: "Campaigns designed for decision makers: CEOs, owners, Commercial Directors, Sales & Marketing Managers, Export Managers." },
        { title: "Lead generation, not vanity metrics", desc: "The goal is B2B leads, quote requests, dealers, distributors, wholesalers and professional partnerships — not likes and followers." },
        { title: "Connected to the ecosystem", desc: "Every lead from a campaign can be directed to your website, served by the AI Secretary and logged in your CRM." },
      ],
      bullets: ["Facebook Ads", "Instagram Ads", "Meta Ads", "B2B Leads", "Quote requests", "Dealers & Distributors", "Wholesalers", "Commercial opportunities"],
      cta: "Discuss your campaign",
    },
    websites: {
      eyebrow: "02 — SERVICE",
      title: "Websites & Web Development",
      lead: "Professional websites for businesses — designed as a sales tool, not just a digital presence.",
      message: "Your website is not just your digital presence. It is a sales tool.",
      blocks: [
        { title: "GR / EN Website Development", desc: "Greek, English and bilingual websites for companies addressing the Greek and international markets — exporters, producers, wholesalers, suppliers." },
        { title: "Designed for leads", desc: "Contact forms, lead generation forms, request-a-quote flows and landing pages that turn traffic into commercial enquiries." },
        { title: "Full integrations", desc: "Meta Pixel, Analytics, CRM integration, Business Email and SEO-ready structure — ready to connect with the rest of your digital ecosystem." },
      ],
      bullets: ["Corporate Websites", "B2B Websites", "Bilingual GR / EN", "Landing Pages", "Web Applications", "Digital Platforms", "E-commerce", "Responsive & Mobile Optimization", "Request a Quote", "SEO-ready structure"],
      cta: "Build your new website",
    },
    crm: {
      eyebrow: "03 — SERVICE",
      title: "Business CRM",
      lead: "Organise customers, leads, opportunities and sales in one system — from the first contact to a closed deal.",
      message: "Every lead. Every conversation. Every opportunity. In one place.",
      blocks: [
        { title: "Sales pipeline", desc: "Track every opportunity from NEW LEAD to WON: CONTACTED → MEETING → OFFER → WON, with full customer history." },
        { title: "Sales team organisation", desc: "Tasks, notes, meetings, reminders and follow-ups assigned per team member — nothing gets lost." },
        { title: "Reports & dashboard", desc: "A clear view of your sales: leads, active opportunities, follow-ups and won deals in one dashboard." },
      ],
      bullets: ["Customers & Companies", "Leads & Contacts", "Opportunities & Deals", "Sales Pipeline", "Tasks & Reminders", "Meetings & Notes", "Offers", "Lead & customer history", "Sales team management", "Reports & Dashboard"],
      cta: "Request a CRM presentation",
    },
    "ai-secretary": {
      eyebrow: "04 — SERVICE",
      title: "AI Secretary",
      lead: "An AI Business Assistant acting as your company's first digital line of communication — not just a chatbot.",
      message: "Your business available 24/7.",
      message2: "From the first question to the CRM, automatically.",
      blocks: [
        { title: "Serving prospects", desc: "Answers frequent questions, provides basic information and logs requests — even outside working hours." },
        { title: "Lead capture & qualification", desc: "Collects contact details, understands the request and qualifies the interest before it reaches your sales team." },
        { title: "CRM connection", desc: "Where an integration exists, every new lead is automatically logged in the CRM and the responsible salesperson is notified for follow-up." },
      ],
      bullets: ["Answers to frequent questions", "Lead capture", "Lead qualification", "Request logging", "Appointment requests", "Request routing", "CRM connection", "Sales rep notification", "Follow-up workflows", "24/7 digital availability"],
      cta: "Request a Demo",
    },
    "business-email": {
      eyebrow: "05 — SERVICE",
      title: "Business Email",
      lead: "Professional company email on your own domain, through reliable mail server infrastructure.",
      message: "Professional communication with your corporate identity.",
      blocks: [
        { title: "Company accounts", desc: "Addresses like info@company.gr, sales@company.gr and name@company.gr that strengthen your corporate identity in every conversation." },
        { title: "Access anywhere", desc: "Webmail, mobile and desktop access with full setup across your team's devices." },
        { title: "Management & support", desc: "Account management, email configuration and technical support — as a complementary service of your digital ecosystem." },
      ],
      bullets: ["Email hosting", "Company email accounts", "Webmail", "Mobile access", "Desktop access", "Email configuration", "Account management", "Technical support"],
      cta: "Request a quote",
    },
  },
  privacy: {
    title: "Privacy Policy",
    updated: "Last updated: July 2026",
    sections: [
      { h: "Data controller", p: "The controller of personal data collected through this website is DIGITAL COMPANY (digital-company.gr), 58 Karterou, Heraklion, Crete. For any privacy matter you can contact us at info@digital-company.gr or +30 6989 164 257." },
      { h: "What data we collect", p: "Through the contact form we collect the details you provide: full name, company name, email, phone, website, services of interest and your message. This data is used exclusively to respond to your request and for our business communication with you." },
      { h: "Legal basis", p: "Processing is based on your consent (Article 6(1)(a) GDPR), which you provide via the relevant checkbox, as well as on our legitimate interest in serving business enquiries." },
      { h: "Data retention", p: "Form data is kept for as long as needed to serve your request and any resulting collaboration, and is deleted or anonymised when no longer necessary." },
      { h: "Your rights", p: "You have the right of access, rectification, erasure, restriction, portability and objection to the processing of your data, as well as the right to withdraw your consent at any time. You also have the right to lodge a complaint with the Hellenic Data Protection Authority (www.dpa.gr)." },
      { h: "Security", p: "We apply appropriate technical and organisational measures to protect your data. We do not sell or share your details with third parties for their own purposes." },
    ],
  },
  cookies: {
    title: "Cookies Policy",
    updated: "Last updated: July 2026",
    sections: [
      { h: "What cookies are", p: "Cookies are small text files stored on your device when you visit a website, helping it function and improve." },
      { h: "Essential cookies", p: "We use strictly necessary cookies/storage mechanisms for the website to function and to store your consent choice. These do not require consent." },
      { h: "Analytics cookies", p: "Only with your consent, we use analytics cookies to understand how the website is used and to improve it. You can change your choice at any time by clearing the site data in your browser." },
      { h: "Managing consent", p: "On your first visit a consent banner appears where you can accept all cookies or only the essential ones. No non-essential tracking is activated before your consent." },
    ],
  },
  notFound: {
    title: "Page not found",
    sub: "The link you followed does not match a page.",
    cta: "Back to home",
  },
  seo: {
    home: { title: "DIGITAL COMPANY — B2B Digital & AI Solutions", desc: "B2B Advertising, GR/EN website development, CRM, AI Secretary & Business Email in one integrated digital ecosystem for B2B companies." },
    "b2b-advertising": { title: "B2B Advertising & Meta Ads | DIGITAL COMPANY", desc: "B2B advertising on Facebook, Instagram & Meta Ads focused on B2B leads, quote requests and professional partnerships." },
    websites: { title: "GR/EN Website Development & Web Apps | DIGITAL COMPANY", desc: "Corporate, B2B and bilingual websites, landing pages, e-commerce and web applications designed as sales tools." },
    crm: { title: "Business & Sales CRM | DIGITAL COMPANY", desc: "Business CRM for organising leads, customers, opportunities and sales pipeline. Every opportunity in one place." },
    "ai-secretary": { title: "AI Secretary for Business | DIGITAL COMPANY", desc: "AI Business Assistant for 24/7 service, lead capture & qualification and automatic CRM connection." },
    "business-email": { title: "Business Email Hosting | DIGITAL COMPANY", desc: "Professional company email on your own domain: hosting, webmail, mobile & desktop access and technical support." },
    projects: { title: "Our Work | DIGITAL COMPANY", desc: "Selected websites, e-commerce and web applications we have built: ESPAMANAGER.GR, QALS.GR, BLOUZES4ALL.GR, NOETICALAB.GR." },
    solutions: { title: "B2B Solutions | DIGITAL COMPANY", desc: "Digital solutions for B2B companies: B2B Presence, B2B Growth and B2B Complete packages with Advertising, Web, AI and CRM." },
    about: { title: "About | DIGITAL COMPANY", desc: "Marketing, Technology & AI in one unified B2B ecosystem. Discover the DIGITAL COMPANY philosophy." },
    contact: { title: "Contact | DIGITAL COMPANY", desc: "Request a free assessment for B2B Advertising, Website, CRM, AI Secretary or Business Email." },
    privacy: { title: "Privacy Policy | DIGITAL COMPANY", desc: "How we collect, process and protect your personal data." },
    cookies: { title: "Cookies Policy | DIGITAL COMPANY", desc: "Information about the cookies we use and managing your consent." },
  },
};

export default en;
